import * as z from "zod/v4";

export const updateRecoverSettings = {
  name: "updateRecoverSettings" as const,
  input: z.object({
    defaultRepName: z.string().optional(),
    brandName: z.string().optional(),
    supportEmail: z.string().optional(),
    handOffToSupportEnabled: z.boolean().optional(),
    excludeExternalSmsUnsubscribers: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
